import { API } from '@edulastic/api'
import { notification } from '@edulastic/common'

const api = new API()

export const doValidate = (params, endpoint, method = 'post') =>
  api
    .callApi({
      url: endpoint,
      method,
      data: method === 'post' ? params : {},
      params: method === 'get' ? params : {},
    })
    .then(({ data }) => data)
    .catch(({ data: errorData }) =>
      notification({ msg: errorData?.message || 'Something went wrong' })
    )

export const submit = (params, endpoint, method, isSlowApi) =>
  api
    .callApi({
      useSlowApi: isSlowApi,
      url: endpoint,
      method,
      data: params,
    })
    .then(({ data, status }) => ({ ...data, status }))
    .catch((errorObj) => {
      const { data: errorData } = errorObj
      if (errorObj?.response?.data?.message === 'DistrictNotFound') {
        notification({
          msg: 'District not found!',
          messageKey: 'apiFormErr',
        })
      } else {
        notification({
          msg: errorData?.message || errorObj?.response?.data?.message,
          messageKey: 'apiFormErr',
        })
      }
    })

export const uploadFile = (file, endPoint) => {
  const formData = new FormData()
  formData.append('file', file)
  return api
    .callApi({
      url: endPoint,
      method: 'post',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((result) => result.data.result)
}

export const saveStandard = (uploadData) =>
  api.callApi({
    url: `admin-tool/standards`,
    method: 'post',
    data: uploadData,
  })

export const getPdlStandardsForPdlToPaImport = (pdlCurrId) =>
  api
    .callApi({
      method: 'get',
      url: `admin-tool/standards/pdl-to-pa/${pdlCurrId}`,
      useSlowApi: true,
    })
    .then(({ data }) => data.result || data)

export const paToPdlStandardsImport = (data) =>
  api
    .callApi({
      method: 'post',
      url: `admin-tool/standards/pa-to-pdl`,
      data,
      responseType: 'text', // Handle CSV response as text
      useSlowApi: true,
    })
    .then((response) => {
      // For CSV responses, axios returns the data directly in response.data
      return response.data
    })

export const receivePDLCurriculums = () =>
  api
    .callApi({
      method: 'get',
      url: 'admin-tool/curriculums/pdl',
      useSlowApi: true,
    })
    .then(({ data }) => data.result || data)

export const unifyStandards = (mappings, action = 'add') =>
  api
    .callApi({
      method: 'put',
      url: 'admin-tool/unify-standards',
      data: { mappings, action },
    })
    .then(({ data }) => data.result || data)
